import { Component, Input } from "@angular/core";

@Component({
  selector: "source-badge",
  templateUrl: "./source-badge.component.html",
})
export class SourceBadgeComponent {
  @Input() public source: string;

  get icon(): string {
    switch (this.source) {
      case "web": return "fad fa-user";
      case "mcp": return "fad fa-microchip-ai";
      case "system": return "fad fa-cog";
      default: return "";
    }
  }

  get label(): string {
    switch (this.source) {
      case "web": return "Modified via Web UI";
      case "mcp": return "Modified via MCP";
      case "system": return "System operation";
      default: return "";
    }
  }
}
